export default "__VITE_ASSET__DpS2ybym__"